module.exports = __webpack_public_path__ + "static/media/Reman_Major_Power Module_Xparent.b2214ffd.png";